import React from "react";
import { Box, styled, Grid, Typography, Button, Stack } from "@mui/material";
import LandingHeader from "../../layout/header";
import Footer from "../../layout/footer";
import { AboutTitle, BlueBox, BtnAccess, InfoItemBox } from "./style";
import { RootStyle, SubTitle, Text } from "./style";
import AboutImg from "../../images/landing/about illustration.png";
import HandImg from "../../images/landing/hand.png";
import TechImg from "../../images/landing/tech.png";
import DigitiseImg from "../../images/landing/digitise.svg";
import ExpoImg from "../../images/landing/expo.svg";
import { Link } from "react-router-dom";
import { DigitiseText, ExponentialText } from "./Texts";
import AccessNow from "./AccessNow";
import DeviceIcon from "../../images/landing/devices white.svg";
import UserIcon from "../../images/landing/users white.svg";
import StarIcon from "../../images/landing/stars white.svg";

function About() {
  return (
    <Box sx={{ background: "#fff" }}>
      <LandingHeader />
      <RootStyle sx={{ my: "40px" }}>
        <Stack spacing="64px">
          <BlueBox>
            <BlueBox
              sx={{
                flex: "1",
                background: { xs: "transparent", md: "#FAFAFA29" },
              }}
            >
              <Grid container>
                <Grid
                  item
                  md={5}
                  xs={12}
                  order={{ xs: 2, md: 1 }}
                  spacing="32px"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: { xs: "center", md: "flex-start" },
                    justifyContent: "space-evenly",
                  }}
                >
                  <AboutTitle>
                    Join The Digital Revolution and Start Managing Your Business
                    Efficiently
                  </AboutTitle>
                  <Link to="/inventory/login">
                    <BtnAccess>Access Now</BtnAccess>
                  </Link>
                </Grid>
                <Grid
                  item
                  md={7}
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    order: { xs: 1, md: 2 },
                  }}
                >
                  <img
                    style={{ marginTop: "16px" }}
                    width="100%"
                    src={AboutImg}
                    alt=""
                  />
                </Grid>
              </Grid>
            </BlueBox>
          </BlueBox>

          <Stack spacing="40px">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Streamline Business Operations and Empower Growth
            </AboutTitle>
            <Grid container>
              <Grid item md={4} xs={12}>
                <img width="100%" src={HandImg} alt="" />
              </Grid>
              <Grid item md={8} xs={12} px={{ xs: "0", md: "32px" }}>
                <Text sx={{ lineHeight: "35px" }}>
                  ManageKaro is a comprehensive billing and inventory management
                  system designed to empower businesses of all sizes to
                  streamline their operations, optimise resource utilisation,
                  and focus on their core growth strategies. By automating
                  essential tasks such as invoicing, inventory tracking, and
                  quotation generation, ManageKaro alleviates the administrative
                  burden on business owners, allowing them to dedicate more time
                  and energy on growing their businesses.
                </Text>
                <Text sx={{ my: "32px", lineHeight: "35px" }}>
                  ManageKaro's intuitive interface and user-friendly features
                  make it a seamless solution for businesses seeking to enhance
                  their efficiency and productivity. With its cloud-based
                  architecture, ManageKaro ensures real-time data access and
                  collaboration, empowering businesses to make informed
                  decisions anytime, anywhere.
                </Text>
                <Text sx={{ lineHeight: "35px" }}>
                  Embrace ManageKaro and experience the freedom to elevate your
                  business operations, maximise your potential, and achieve
                  sustainable growth.
                </Text>
              </Grid>
            </Grid>
          </Stack>
          <Stack spacing="40px" alignItems="center">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Unlock business potential with the right technology
            </AboutTitle>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: { xs: "100%", md: "60%" },
              }}
            >
              <img width="100%" src={TechImg} alt="" />
            </Box>
            <Text sx={{ textAlign: "center" }}>
              In today's dynamic business landscape, embracing technology is no
              longer a choice but a necessity. Digitising your operations and
              adopting the right business management tools can unlock a world of
              benefits for your business, regardless of its size or industry.
              Whether you run a bustling store, a pharmacy catering to community
              health, or a retail outlet brimming with merchandise, ManageKaro
              can streamline your processes, enhance customer experience, and
              propel your business towards success.
            </Text>
          </Stack>
          <Box sx={{ background: "#F9F9F9", borderRadius: "24px" }}>
            <Grid container>
              <Grid item xs={8}>
                <Box sx={{ p: "40px" }}>
                  <AboutTitle sx={{ color: "#4DAF51" }}>
                    Digitise Your Business, Simplify Success
                  </AboutTitle>
                  <Text
                    sx={{ mt: "16px", display: { xs: "none", md: "block" } }}
                  >
                    {DigitiseText}
                  </Text>
                </Box>
              </Grid>
              <Grid
                item
                xs={4}
                sx={{
                  background: "#AF994D14",
                  borderBottomLeftRadius: { xs: "102px", md: "204px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  py: "32px",
                }}
              >
                <img width="70%" src={DigitiseImg} alt="" />
              </Grid>
            </Grid>
            <Text sx={{ mt: "16px", display: { xs: "block", md: "none" } }}>
              {DigitiseText}
            </Text>
          </Box>
          <Box sx={{ background: "#F9F9F9", borderRadius: "24px" }}>
            <Grid container>
              <Grid item xs={8}>
                <Box sx={{ p: "40px" }}>
                  <AboutTitle sx={{ color: "#4DAF51" }}>
                    Unlocking Exponential Growth
                  </AboutTitle>
                  <Text
                    sx={{ mt: "16px", display: { xs: "none", md: "block" } }}
                  >
                    {ExponentialText}
                  </Text>
                </Box>
              </Grid>
              <Grid
                item
                xs={4}
                sx={{
                  background: "#AF994D14",
                  borderTopLeftRadius: { xs: "102px", md: "204px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  py: "32px",
                }}
              >
                <img width="70%" src={ExpoImg} alt="" />
              </Grid>
            </Grid>
            <Text sx={{ mt: "16px", display: { xs: "block", md: "none" } }}>
              {ExponentialText}
            </Text>
          </Box>

          <BlueBox>
            <BlueBox
              sx={{
                flex: "1",
                alignItems: "center",
                background: { xs: "transparent", md: "#FAFAFA29" },
              }}
            >
              <Grid
                container
                spacing={5}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Grid item sm={3} xs={12}>
                  <InfoItemBox>
                    <img width="56px" height="56px" src={DeviceIcon} alt="" />

                    <Box sx={{ display: "flex" }}>
                      <SubTitle sx={{ color: "#484C52" }}>Multi</SubTitle>
                      <SubTitle sx={{ mx: 0.5, color: "#484C52" }}>-</SubTitle>
                      <SubTitle sx={{ color: "#FFFFFF" }}>Device</SubTitle>
                    </Box>
                    <Text>
                      Use on any device: Desktop, Mobile Phone or Laptop
                    </Text>
                  </InfoItemBox>
                </Grid>
                <Grid item md={3} xs={12}>
                  <InfoItemBox>
                    <img width="56px" height="56px" src={UserIcon} alt="" />

                    <Box sx={{ display: "flex" }}>
                      <SubTitle sx={{ color: "#484C52" }}>Multi</SubTitle>
                      <SubTitle sx={{ mx: 0.5, color: "#484C52" }}>-</SubTitle>
                      <SubTitle sx={{ color: "#fff" }}>User</SubTitle>
                    </Box>
                    <Text>
                      Mange your workforce and employees through limited access
                    </Text>
                  </InfoItemBox>
                </Grid>
                <Grid item md={3} xs={12}>
                  <InfoItemBox>
                    <img width="56px" height="56px" src={StarIcon} alt="" />

                    <Box sx={{ display: "flex" }}>
                      <SubTitle sx={{ color: "#484C52" }}>Rated</SubTitle>
                      <SubTitle sx={{ mx: 0.5, color: "#484C52" }}>-</SubTitle>
                      <SubTitle sx={{ color: "#fff" }}>4.8/5</SubTitle>
                    </Box>
                    <Text>Rated by our happy customers</Text>
                  </InfoItemBox>
                </Grid>
              </Grid>
            </BlueBox>
          </BlueBox>

          <AccessNow />
        </Stack>
      </RootStyle>
      <Footer />
    </Box>
  );
}

export default About;
